import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { AuthContextProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';               
import { CultivationCompanyContextProvider } from './context/CultivationCompanyContext';
import { CompanyContextProvider } from './context/CompanyContext';         
import { WorkoutsContextProvider } from './context/WorkoutContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthContextProvider>
      <LanguageProvider>                                                
        <CultivationCompanyContextProvider>
          <CompanyContextProvider>                                       
            <WorkoutsContextProvider>
              <App />
            </WorkoutsContextProvider>
          </CompanyContextProvider>
        </CultivationCompanyContextProvider>
      </LanguageProvider>
    </AuthContextProvider>
  </React.StrictMode>
);
